import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import checkUndefinedNullOrEmpty from '../../utils/tools/checkUndefinedNullOrEmpty';
import getStyleQuery from '../../utils/tools/getStyleQuery';
import Iconify from '../iconify/component';
import LinkItem from './link-item';
import { type CustomBreadcrumbsProps } from './types';

function Separator() {
    return (
        <Box
            component="span"
            sx={{
                width: 4,
                height: 4,
                borderRadius: '50%',
                bgcolor: 'text.disabled',
            }}
        />
    );
}

export default function CustomBreadcrumbs({ links, action, heading, backAction, moreLink, activeLast, sx, ...other }: CustomBreadcrumbsProps) {
    const lastLink = links?.[links?.length - 1]?.name;

    return (
        <Box sx={{ ...sx }}>
            <Stack direction="row" alignItems="center">
                {backAction && (
                    <IconButton size="small" onClick={backAction} sx={{ mr: 1 }}>
                        <Iconify icon="line-md:chevron-left" sx={{ width: '1.5em', height: '1.5em' }} />
                    </IconButton>
                )}
                <Box sx={{ flexGrow: 1 }}>
                    {/* HEADING */}
                    {heading && (
                        <Typography
                            component="h1"
                            variant="h3"
                            gutterBottom
                            sx={{
                                [getStyleQuery()]: {
                                    mb: checkUndefinedNullOrEmpty(links) ? 0 : undefined,
                                },
                            }}
                        >
                            {heading}
                        </Typography>
                    )}

                    {/* BREADCRUMBS */}
                    {!!links?.length && (
                        <Breadcrumbs separator={<Separator />} {...other}>
                            {links?.map((link) => <LinkItem key={link.name || ''} link={link} activeLast={activeLast} disabled={link.name === lastLink} />)}
                        </Breadcrumbs>
                    )}
                </Box>

                {action && <Box sx={{ flexShrink: 0 }}> {action} </Box>}
            </Stack>

            {/* MORE LINK */}
            {!!moreLink && (
                <Box sx={{ mt: 2 }}>
                    {moreLink.map((href) => (
                        <Link key={href} href={href} variant="caption" target="_blank" rel="noopener" sx={{ display: 'table' }}>
                            {href}
                        </Link>
                    ))}
                </Box>
            )}
        </Box>
    );
}
